import * as api from './index';
const t = '/confirmations';

export default {
  get: api.get(t),
  create: api.post(t),
  getItem: api.get(`${t}/item/:id`),
  update: api.put(`${t}/:id`),
  del: api.del(`${t}/:id`)
};